import AddCompanyPage from './AddCompany';
import { createAddCompanyHandle } from './handle';

export default {
  Component: AddCompanyPage,
  createHandle: createAddCompanyHandle
};
